import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import NgxSpinnerTextService from '@app/shared/ngx-spinner-text.service';
import { AppUiCustomizationService } from '@shared/common/ui/app-ui-customization.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet></router-outlet>
        <ngx-spinner type="ball-clip-rotate" size="medium" color="#5ba7ea">
            @if (ngxSpinnerText) {
                <p>{{ getSpinnerText() }}</p>
            }
        </ngx-spinner>
    `,
    standalone: false,
})
class RootComponent implements OnInit, OnDestroy {
    ngxSpinnerText: NgxSpinnerTextService;

    private routerEventsSubscription: Subscription;

    constructor(
        _ngxSpinnerText: NgxSpinnerTextService,
        private router: Router,
        private uiCustomizationService: AppUiCustomizationService,
    ) {
        this.ngxSpinnerText = _ngxSpinnerText;
    }

    ngOnInit(): void {
        this.routerEventsSubscription = this.router.events.subscribe((event: NavigationEnd) => {
            setTimeout(() => {
                this.toggleBodyCssClass(event.url);
            }, 0);
        });
    }

    ngOnDestroy(): void {
        if (this.routerEventsSubscription) {
            this.routerEventsSubscription.unsubscribe();
        }
    }

    getSpinnerText(): string {
        return this.ngxSpinnerText.getText();
    }

    private toggleBodyCssClass(url: string): void {
        if (url) {
            if (url === '/') {
                if (abp.session.userId > 0) {
                    this.setAppModuleBodyClassInternal();
                } else {
                    this.setAccountModuleBodyClassInternal();
                }
            }

            if (url.indexOf('/account/') >= 0) {
                this.setAccountModuleBodyClassInternal();
            } else {
                this.setAppModuleBodyClassInternal();
            }
        }
    }

    private setAppModuleBodyClassInternal(): void {
        const currentBodyClass = document.body.className;
        let classesToRemember = '';

        if (currentBodyClass.indexOf('brand-minimize') >= 0) {
            classesToRemember += ' brand-minimize ';
        }

        if (currentBodyClass.indexOf('aside-left-minimize') >= 0) {
            classesToRemember += ' aside-left-minimize';
        }

        if (currentBodyClass.indexOf('brand-hide') >= 0) {
            classesToRemember += ' brand-hide';
        }

        if (currentBodyClass.indexOf('aside-left-hide') >= 0) {
            classesToRemember += ' aside-left-hide';
        }

        if (currentBodyClass.indexOf('swal2-toast-shown') >= 0) {
            classesToRemember += ' swal2-toast-shown';
        }

        document.body.className = this.uiCustomizationService.getAppModuleBodyClass() + ' ' + classesToRemember;
    }

    private setAccountModuleBodyClassInternal(): void {
        const currentBodyClass = document.body.className;
        let classesToRemember = '';

        if (currentBodyClass.indexOf('swal2-toast-shown') >= 0) {
            classesToRemember += ' swal2-toast-shown';
        }

        document.body.className = this.uiCustomizationService.getAccountModuleBodyClass() + ' ' + classesToRemember;
    }
}

export default RootComponent;
